/**
 * Navigation
 */

import {
	lockBodyScrolling,
	unlockBodyScrolling
} from '../../../../../shared/utils/scroll';

import SelectorEngine from '../../../../../shared/dom/selector-engine';
import Manipulator from '../../../../../shared/dom/manipulator';
import EventHandler from '../../../../../shared/dom/event-handler';

import Drawer from '../../../../../shared/components/drawer';
import {isElement} from '../../../../../shared/utils/is';
import {getInlineConfig} from '../../../../utils';
import menu from '../../index';

// -------
// Private
// -------

const NAME      = 'sub-menu';
const DATA_KEY  = `ifab.${NAME}`;
const EVENT_KEY = `.${DATA_KEY}`;

const MAIN_MENU = SelectorEngine.findOne('.page-header .main-nav');
const DRAWER    = SelectorEngine.findOne('#page-submenu-drawer');

/**
 * Drawer (Navigationsoverlay)
 */
const setupDrawer = () => {
	if(!DRAWER) {
		return false;
	}

	return new Drawer(DRAWER, {
		closeButton: 0
	});
};

// -------
// Public
// -------

const init = () => {
	const collection = SelectorEngine.find('.-has-sub[data-page]', MAIN_MENU);
	const DRAWER_API = setupDrawer();

	let subTpl = null;

	if(!DRAWER_API || !collection.length) {
		return;
	}

	for(const element of collection) {
		EventHandler.on(element, 'click', (event) => {
			event.preventDefault();

			const SUB_MENU = SelectorEngine.next(element, '.nav-list')[0];
			let linkLbl = event.delegateTarget.textContent;

			if(!SUB_MENU) {
				return;
			}

			subTpl = Manipulator.createElementFrom(`<div class="content"><div class="header nav-header"><h5 clasS="header__title">${linkLbl}</h5></div><nav class="nav main-nav" data-nav="main" id="main-nav">${SUB_MENU.outerHTML}</nav></div>`);
			DRAWER_API.elements.body.innerHTML = '';
			Manipulator.elementAppend(subTpl, DRAWER_API.elements.body);

			DRAWER_API.show();
		});
	}
};

// -------
// Export
// -------

export default init;